import { Box, Button, Popover, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography } from '@mui/material';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import './../styles/blog.css';
import { GetAllBlog, DeleteBlog, UpdateBlog } from '../services/ApiServices/BlogService';
import { useNavigate } from 'react-router-dom';
import BlogEditor from '../components/BlogEditor';

function AdminBlogManagement({ setLoading }: any) {
    const [blogs, setBlogs] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [popoverAnchorEl, setPopoverAnchorEl] = useState<null | HTMLElement>(null);
    const [currentBlogId, setCurrentBlogId] = useState('');
    const [currentBlog, setCurrentBlog] = useState({} as any);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [editorContent, setEditorContent] = useState('');
    const navigate = useNavigate();

    const fetchBlogs = async () => {
        let userInfos = null;
        setLoading(true);
        try {
            userInfos = await GetAllBlog();
            setLoading(false);
            setBlogs(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            setLoading(false);
            return;
        }
    }

    useEffect(() => {
        fetchBlogs();
    }, []);

    const handleCreateBlog = () => {
        navigate('/dashboard/create-blog');
    }

    const handlePopoverOpen = (event: any, blog: any) => {
        setPopoverAnchorEl(event.currentTarget);
        setCurrentBlogId(blog.id);
        setCurrentBlog(blog);
    };

    const handlePopoverClose = () => {
        setPopoverAnchorEl(null);
    };

    const handleUpdateBlog = () => {
        const blog = blogs.find((blog: any) => blog.id === currentBlogId);
        if (blog) {
            setTitle(blog.title);
            setEditorContent(blog.content);
            setUpdateDialogOpen(true);
            handlePopoverClose();
        }
    };

    const handleDeleteButtonClick = () => {
        setDeleteDialogOpen(true);
        handlePopoverClose();
    };

    const handleDeleteConfirm = async () => {
        try {
            await DeleteBlog(currentBlogId);
            fetchBlogs(); 
        } catch (error) {
            console.error("Error deleting blog:", error);
        } finally {
            setDeleteDialogOpen(false);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
    };

    const handleUpdateCancel = () => {
        setUpdateDialogOpen(false);
    };

    const handleFormSubmit = async () => {
        try {
            const formData = new FormData();
            formData.append("id", currentBlog.id);
            formData.append("userId", currentBlog.userId);
            formData.append("title", title);
            formData.append("content", editorContent);
            formData.append("status", "Active");
            formData.append("createdAt", "");
            await UpdateBlog(formData);
            fetchBlogs();
        } catch (error) {
            console.error("Error updating blog:", error);
        } finally {
            setUpdateDialogOpen(false);
        }
    };

    const handleEditorChange = (event: any, editor: any) => {
        setEditorContent(editor.getData());
    };

    return (
        <>
            <div className='flex justify-center'>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCreateBlog}
                    sx={{ mb: 4, mt: 3 }}
                >
                    Tạo blog
                </Button>
            </div>

            <div className="blogs-wrapper">
                {blogs.map((blog: any) => (
                    <Box

                        key={blog.id}
                        className="blog-inside-wrapper mt-5 mb-5 p-0"
                        sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, maxWidth: 800, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}
                    >
                        <Button
                            style={{ marginBottom: 1, alignSelf: 'flex-end', color: 'black', fontWeight: 'bold' }}
                            onClick={(event) => handlePopoverOpen(event, blog)}
                        >
                            . . .
                        </Button>
                        <img style={{ width: "100%" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8Dyq1gtNFnF2O9ue7Ol5Ku5kSWigqguiVlA&s" alt="Blog" />
                        <div style={{ fontSize: "20px" }} className="about-header text-center font-bold">
                            <h1>{blog.title}</h1>
                            <div className="underline"></div>
                        </div>
                        <div className="card-wrapper mt-2">
                            <p>{parse(blog.content)}</p>
                        </div>

                    </Box>
                ))}
            </div>

            <Popover
                open={Boolean(popoverAnchorEl)}
                anchorEl={popoverAnchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box p={2}>
                    <Button variant="text" onClick={handleUpdateBlog}>
                        Update
                    </Button>
                    <Button variant="text" onClick={handleDeleteButtonClick}>
                        Delete
                    </Button>
                </Box>
            </Popover>

            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteCancel}
                aria-labelledby="delete-dialog-title"
            >
                <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Are you sure you want to delete this blog?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteConfirm} color="secondary" autoFocus>
                        Yes
                    </Button>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={updateDialogOpen}
                onClose={handleUpdateCancel}
                aria-labelledby="update-dialog-title"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="update-dialog-title">Update Blog</DialogTitle>
                <DialogContent>
                    <Box
                        className="user-info-wrapper mt-5 mb-5"
                        sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, display: 'flex', flexDirection: 'column', gap: 2 }}
                    >
                        <div style={{ fontSize: "20px" }} className="about-header text-center font-bold">
                            <h1>Giới thiệu</h1>
                            <div className="underline"></div>
                        </div>
                        <TextField
                            id="title-basic"
                            label="Title"
                            variant="outlined"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            fullWidth
                        />
                        <BlogEditor handleEditorChange ={handleEditorChange} />
                        <div className="text-red-500">{errorMessage}</div>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleFormSubmit} color="primary" variant="contained">
                        Submit
                    </Button>
                    <Button onClick={handleUpdateCancel} color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AdminBlogManagement;
